<template>
  <div>
    <el-dialog
      class="dialog-test"
      :visible="visible"
      append-to-body
      @close="onConfirm"
      width="640px"
    >
      <div class="content">
        <div class="title">考试条件</div>
        <div id="test-content">
          <div class="test-title">
            <span class="icon"></span>
            <span class="test-name">考试名称</span>
          </div>
          <div style="margin-bottom: 20px" class="test-name-content">
            {{ testCondition.name }}
          </div>
          <div class="test-title">
            <span class="icon"></span>
            <span class="test-name">
              {{
                testCondition.join_type == 1
                  ? "完成以下所有课程学习要求"
                  : "完成以下任意课程学习要求"
              }}
            </span>
          </div>
          <div class="course-content">
            <div
              class="course-info"
              v-for="(item, index) in testCondition.courseList"
              :key="index"
            >
              <span class="course-name" @click="goToCourse(item)">
                《{{ item.course_title }}》
              </span>
              <a class="course-rate" v-if="item.rate && item.rate != 100">
                课程学习进度达到
                <a class="rate">{{ item.rate }}%</a>
                以上
              </a>
              <a class="course-rate" v-else-if="item.rate && item.rate == 100">
                课程结束
              </a>
              <a class="course-rate" v-else>报名成功</a>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <el-button @click="onConfirm">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TestConditionModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    testCondition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal(value) {
      this.visible = value;
    },
  },
  methods: {
    onConfirm() {
      this.visible = false;
      this.$emit("update:showModal", false);
    },
    goToCourse(course) {
      // 开启禁止跨校区购买，不跳转课程详情
      if (!course.isCanBuy) {
        this.$message.warning("暂无访问跨校区课程的权限");
        return;
      }

      if(course.type==2){
          this.$router.push({
            name: "PackageDetail",
            params: { id: course.course_id },
          });
      }else{
        this.$router.push({
          name: "CourseShow",
          params: { id: course.course_id },
        });
      }

      // 根据课程id跳转到课程详情页
      this.onConfirm();
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-test {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 16px 24px 0 24px;
  }
  .content {
    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 24px;
      margin-bottom: 16px;
    }
    #test-content {
      max-height: 320px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      & {
        -ms-overflow-style: none;
      }
      & {
        overflow: -moz-scrollbars-none;
      }
      .test-title {
        margin-bottom: 6px;
        .icon {
          display: inline-block;
          width: 3px;
          height: 15px;
          opacity: 1;
          background: #ffbc33;
          border-radius: 2px;
          vertical-align: middle;
        }
        .test-name {
          display: inline-block;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
          margin-left: 6px;
          vertical-align: middle;
        }
      }
      .test-name-content {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      .course-content {
        .course-info {
          margin-bottom: 8px;
          //display: inline-block;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          line-height: 22px;
          .course-name {
            display: inline-block;
            color: $primary-color;
            vertical-align: middle;
            margin-right: 2px;
            cursor: pointer;
          }
          .course-name:hover {
            color: $primary-color-hover;
          }
          .course-rate {
            //display: inline-block;
            vertical-align: middle;
            color: #999;
            .rate {
              color: #ffbc33;
            }
          }
        }
      }
    }
  }
  /deep/ .el-dialog__footer {
    padding: 6px 24px 24px 24px;
  }
}
</style>
